import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {Authority} from '../shared/constants/authority.constants';
import {ResolvePagingParams} from '../core/services';

const routes: Routes = [
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
